import React from 'react';
import PropTypes from 'prop-types';
import { TreeSelect } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';

const TreeSelectInput = ({
  value,
  onChange,
  treeData = [],
  placeholder,
  style,
  className,
  ...props
}) => {
  const { theme } = useTheme();

  return (
    <TreeSelect
      treeData={treeData}
      value={value || []}
      onChange={onChange}
      treeCheckable={true}
      showCheckedStrategy={TreeSelect.SHOW_ALL}
      placeholder={placeholder}
      style={{
        width: "100%",
        backgroundColor: theme.background,
        color: theme.textSecondary,
        borderColor: theme.border,
        ...style
      }}
      className={className}
      {...props}
    />
  );
};

TreeSelectInput.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  treeData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      children: PropTypes.array,
    })
  ),
  placeholder: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default TreeSelectInput; 